import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export default function PageLoader() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        width: "100%",
      }}
    >
      <CircularProgress aria-label="Loading page" />
    </Box>
  );
}
